<template>
    <div class="token-detail">
       <div class="token-info">
            <h3>Token基本信息</h3>
            <div>
                <div class="form-row">
                    <h4>底层</h4>
                    <div class="right">{{token.blockChainText}}</div>
                </div>
                <div class="form-row">
                    <h4>名称</h4>
                    <div class="right" >{{token.name}}</div>
                </div>
                <div class="form-row">
                    <h4>Symbol</h4>
                    <div class="right" >{{token.symbol}}</div>
                </div>
                <div class="form-row">
                    <h4>发行钱包</h4>
                    <div class="right" >{{token.owner_address}}</div>
                </div>
                <div class="form-row">
                    <h4>发行数量</h4>
                    <div class="right" >{{token.amount}}</div>
                </div>
            </div>
       </div>

        <div class="share-zone">
            <mu-switch label="分享页面是否允许其他用户申领" v-model="applyToggle" class="share-toggle" />
            
            <mu-raised-button :disabled="!hasToken" label="分享给朋友" @click="shareMyToken" class="share-button" fullWidth primary/>
        </div>

       <div class="apply-list">
           <h3>申请领取记录</h3>
           <div v-if="applyList.length">
               <div  class="apply-item" v-for="item in applyList" :key="item.hid">
                   <h4>{{item.nick_name}} <span class="apply-time">{{item.create_time}}</span></h4>
                    <p class="address">{{item.address}}</p>
                    <div class="actions">
                        <mu-raised-button v-if="item.status === 1" label="已发放" class="release-button" disabled/>
                        <mu-raised-button v-else label="发放" @click="releaseCandy(item.address, item.hid)" class="release-button" primary/>
                    </div>
               </div>
               
            </div>
            <div style="color: #999" v-else>
                暂无申请
            </div>
       </div>

        <mu-dialog :open="dialog" title="糖果发送" @close="close">
            <mu-text-field  v-model="candyNum" type="number" hintText="请填写要发送的数量"/><br/>
            <mu-flat-button slot="actions" @click="close" primary label="取消"/>
            <mu-flat-button slot="actions" :disabled="sending || !candyNum" primary @click="sendCandy" label="确定"/>
        </mu-dialog>
    </div>
</template>

<script>

import Web3 from 'web3';
import $ from 'jquery';
import u from 'underscore';
import Axios from 'axios';
import moment from 'moment';

const DOMAIN = 'https://preserver.mytokenpocket.vip';

export default {
    name: 'TokenDetail',
    data () {
        return {
            token: {},
            hasToken: false,
            blockChainId: '',
            applyList: [],
            contractAddress: '',
            applyToggle: false,
            from: '',
            targetAddr: '',
            candyNum: '',
            dialog: false,
            msgData: '',
            gasPrice: '',
            sending: false,
            applyId: ''
        }
    },
    created() {
        moment.locale('zh-cn');
        this.contractAddress = this.$route.params.contractAddress;

        window.onGetWalletList = result => {
            let data = JSON.parse(result)
            if (data.wallets && data.wallets.eth) {
                // alert('拿到eth钱包信息');
                this.queryDetail(data.wallets.eth);
            }
            else if (data.wallets && data.wallets.moac) {
                // alert('拿到moac钱包信息');
                this.queryDetail(data.wallets.moac);
            }
        }


        window.onTransactionFinish = result => {
            // alert(result);

            var transResult = JSON.parse(result);

            // console.log(transResult.result);
            // 成功了
            if (transResult.result) {
                $.post(DOMAIN + '/v1/token_apply/update', {
                    status: 1,
                    send_value: 100,
                    id: this.applyId
                }).always(() => this.dialog = false);

                u.each(this.applyList, (apply, index) => {
                    if (apply.hid === this.applyId) {
                        this.applyList[index].status = 1;
                    }
                })
            }
        }

        
        window.web3 = new Web3(new Web3.providers.HttpProvider("https://eth10xie2vce3mhh.jccdex.cn"));
        // window.web3 = new Web3(new Web3.providers.HttpProvider("https://ropsten.infura.io/oaJiGrlgSIEU1bkwyb8s"));
        window.chain3 = new Chain3(new Chain3.providers.HttpProvider('https://chain3.mytokenpocket.vip'));

        if (window.TPJSBrigeClient) {
            window.TPJSBrigeClient.callMessage("getWalletList", '{"type": 1}', "onGetWalletList");
            window.TPJSBrigeClient.callMessage("getWalletList", '{"type": 3}', "onGetWalletList");
        }
            // iOS
        else if (window.webkit) {
            window.webkit.messageHandlers.getWalletList.postMessage({body:{'params': '{"type": 1}', 'callback':'onGetWalletList'}});
            window.webkit.messageHandlers.getWalletList.postMessage({body:{'params': '{"type": 3}', 'callback':'onGetWalletList'}});
        }
        else {
            alert('请在TokenPocket中打开！');
        }

        Axios.get(DOMAIN + '/v1/token_apply/list?start=0&count=100&address=' + this.contractAddress).then(res => {
            let result = res.data;
            if (result.result === 0 && result.data && result.data.length) {
                u.each(result.data, item => {
                    item.create_time = moment(item.create_time).fromNow();
                });
                this.applyList = result.data;
            }
        });

        
    },
    methods: {
        shareMyToken() {
            var title = '我刚刚在TokenPocket上发了' + this.token.amount + '枚' + this.token.symbol + 'Token!'; 
            var desc = '赶快来发行自己的专属Token'; 
            var url = 'http://dapp.mytokenpocket.vip/token-factory/index.html?apply='
                + (this.applyToggle ? '1' : '0') + '&amount=' + this.token.amount
                + '&blockchain_id=' + this.blockChainId
                + '&symbol=' + this.token.symbol + '#/token/share/' + this.contractAddress;

            var params = {
                'title': title,
                'description':desc,
                'url': url, 
                'previewImage': 'http://dapp.mytokenpocket.vip/dapp/tokenmaster.jpg'
            };
            // alert(JSON.stringify(params));

            if (window.webkit) {
                window.webkit.messageHandlers.shareNewsToSNS.postMessage({body:{'params':params,'callback':''}});
            }
            if (window.TPJSBrigeClient) {
                window.TPJSBrigeClient.callMessage("shareNewsToSNS", JSON.stringify(params), '');
            }
            
        },
        queryDetail(wallets) {
            u.each(wallets, wallet => {
                let addr = wallet.address;
                Axios.get(DOMAIN + '/v1/token/list_by_owner?start=0&count=100&address=' + addr).then(res => {
                    let result = res.data;
                    if (result.result === 0 && result.data && result.data.length) {
                        u.each(result.data, item => {
                            if (item.address === this.contractAddress) {
                                item.blockChainText = (+item.blockchain_id === 3) ? '墨客底层' : '以太底层';
                                var totalSupplyBn = web3.utils.toBN(item.total_supply);
                                var decimalBn = web3.utils.toBN(Math.pow(10, +item.decimal));
                                item.amount = totalSupplyBn.div(decimalBn).toString();
                                this.token = item;
                                this.blockChainId = item.blockchain_id;
                                this.hasToken = true;
                                this.from = addr;
                            }
                        });
                    }
                    return res;
                })
            });
        },
        sendCandy() {
            this.sending = true
            let contractInstance = '';
            let abi = [{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_from","type":"address"},{"indexed":true,"name":"_to","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"}];

            var amount = web3.utils.toBN(+this.candyNum);
            var decimals = web3.utils.toBN(Math.pow(10, this.token.decimal));
            var finallyNum = amount.mul(decimals).toString();

            // alert('发送数量:' + finallyNum);

            if (+this.blockChainId === 1) {
                contractInstance = new web3.eth.Contract(abi, this.contractAddress);
                this.msgData = contractInstance.methods.transfer(this.targetAddr, finallyNum).encodeABI();

                web3.eth.getGasPrice().then(gas => {
                    this.gasPrice = gas;
                    this.realSend();
                }).catch(err => {
                    this.sending = false
                    // alert('gas错误：' + err);
                });
            }
            else {
                let contract = new chain3.mc.contract(abi);
                contractInstance = contract.at(this.contractAddress);

                this.msgData = contractInstance.transfer.getData(this.targetAddr, finallyNum);

                chain3.mc.getGasPrice((err, gas) => {
                    if (!err) {
                        this.gasPrice = gas.toString();
                        this.realSend();
                    }
                    else {
                        this.sending = false;
                    }
                })
            }
        },
        realSend() {
            var signedMsg = {};
            signedMsg.from = this.from;
            signedMsg.gasPrice = this.gasPrice;
            signedMsg.gasLimit = 60000;
            signedMsg.to = this.targetAddr;
            signedMsg.contractAddress = this.contractAddress;
            signedMsg.data = this.msgData;
            signedMsg.chainId = this.blockChainId;

            // alert('给客户端的数据：' + JSON.stringify(signedMsg));

            this.sending = false;

            if (window.TPJSBrigeClient) {
                window.TPJSBrigeClient.callMessage("makeTransactions", JSON.stringify(signedMsg), "onTransactionFinish");
            }
            else if (window.webkit) {
                window.webkit.messageHandlers.makeTransactions.postMessage({body:{'params':JSON.stringify(signedMsg),'callback':'onTransactionFinish'}})
            }
        },
        releaseCandy(addr, id) {
            this.targetAddr = addr;
            this.applyId = id;
            this.dialog = true;
        },
        close() {
            this.sending = false;
            this.dialog = false;
        }
    }
}
</script>

<style scoped lang="less">

    .token-info,
    .share-zone,
    .apply-list {
        margin: 0 -15px;
        padding: 20px;
        box-shadow: 0 0.5px 0px #ddd;
    }


    h3 {
        border-left: 2px solid #2096f3;
        padding-left: 10px;
        line-height: 1;
        margin: 10px 0;
    }

    .apply-item {
        position: relative;
        padding: 10px 0;
        border-bottom: 1px solid #F1F1F1;

        .actions {
            position: absolute;
            right: 0;
            top: 10px;
        }

        .release-button {
            height: 26px;
            min-width: 40px;
            border-radius: 14px;
            font-size: 12px;
        }
    }
    .share-zone {
        .share-toggle {
            font-size: 12px;
        }
        
    }
    .share-button {
        margin: 5px 0;
    }

    .address {
        font-size: 12px;
        color: #999;
        margin: 5px 0;
    }

    .apply-time {
        font-size: 12px;
        color: #999;
    }



    .token-info {
        margin-top: -10px;

        .form-row {
            position: relative;
            line-height: 40px;
            height: 40px;
        }

        h4 {
            position: absolute;
            left: 0;
            width: 100px;
            font-weight: normal;
            top: 0;
        }

        .right {
            margin-left: 80px;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/TokenDetail.vue